import React, { useState, useEffect, useRef } from "react";
import Tooltip from "../../../../../components/uiElements/tooltip/Tooltip";

let autoComplete;

var addressComponets = {
  locality: "long_name",
  administrative_area_level_1: "short_name",
  country: "long_name",
  postal_code: "short_name",
};

var fields = {
  locality: "city",
  administrative_area_level_1: "state",
  country: "country",
  postal_code: "zipcode",
};

function handleScriptLoad(updateQuery, autoCompleteRef, onSelect) {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current
  );
  autoComplete.setFields([
    "address_components",
    "geometry",
    "name",
    "formatted_address",
  ]);
  autoComplete.addListener("place_changed", () =>
    handlePlaceSelect(updateQuery, onSelect)
  );
}

async function handlePlaceSelect(updateQuery, onSelect) {
  const addressObject = autoComplete.getPlace();
  const query = addressObject.name;
  updateQuery(query);

  let obj = {};

  for (var i = 0; i < addressObject.address_components.length; i++) {
    var addressType = addressObject.address_components[i].types[0];
    if (addressComponets[addressType]) {
      var val =
        addressObject.address_components[i][addressComponets[addressType]];

      obj = {
        ...obj,
        [fields[addressType]]: val,
      };
    }
  }
  onSelect({
    ...obj,
    address1: query,
    latitude: addressObject.geometry.location.lat(),
    longitude: addressObject.geometry.location.lng(),
    cityFetched: !!obj?.city,
    stateFetched: !!obj?.state,
    countryFetched: !!obj?.country,
    zipcodeFetched: !!obj?.zipcode,
  });
}

function SearchLocationInput({ onSelect, practiceDetails, error }) {
  const [query, setQuery] = useState(practiceDetails.address1);
  const autoCompleteRef = useRef(null);

  useEffect(() => {
    handleScriptLoad(setQuery, autoCompleteRef, onSelect);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="form-group floating mt-n4">
      <input
        className="form-control floating"
        ref={autoCompleteRef}
        onChange={event => setQuery(event.target.value)}
        placeholder={""}
        required
        title=""
        value={query}
      />
      <label className="text-left input-label">{"Enter Address"}</label>
      {error && (
        <Tooltip
          id={error}
          className="errorBtn"
          style={{
            backgroundColor: "white",
            zIndex: 100,
          }}
        >
          {error}
        </Tooltip>
      )}
    </div>
  );
}

export default SearchLocationInput;
